import {convertState} from "./convert-state";

export const negateState = (state) => convertState(
    state,
    {
        forward: v=>!v,
        backward: v=>!v,
    }
);
